<template>
  <div
    :class="{
      'table-cell__focus': inFocus,
      'table-cell__disabled': disabled
    }"
    class="table-cell"
  >
    <slot>
      <label :for="id" class="content-wrapper">
        <span v-if="prefix" class="currency">{{ prefix }}</span>
        <InputCurrency
          v-if="currency"
          :value="value"
          :id="id"
          :placeholder="placeholder"
          :options="
            max != null && min != null
              ? {
                  currency: getCurrency,
                  valueRange: {
                    min: min,
                    max: max
                  }
                }
              : {
                  currency: getCurrency
                }
          "
          autocomplete="off"
          @input="$emit('input', $event)"
          @blur="$emit('blur', $event)"
          @focus="$emit('focus', $event)"
        />
        <input
          v-else
          :value="value"
          :id="id"
          :type="type"
          :placeholder="placeholder"
          autocomplete="off"
          min="0"
          @input="$emit('input', $event.currentTarget.value)"
          @focus="
            inFocus = true
            $event.target.select()
          "
          @blur="inFocus = false"
        />
        <span v-if="sufix" class="currency">{{ sufix }}</span>
      </label>
    </slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InputCurrency from '@/components/_base/elements/InputCurrency'

export default {
  name: 'TableInputCell',
  components: {
    InputCurrency
  },
  props: {
    /** Valor do input */
    value: {
      type: [Number, String],
      default: ''
    },
    /** Id do input */
    id: {
      type: String,
      default: ''
    },
    /** Prefixo do input */
    prefix: {
      type: String,
      default: ''
    },
    /** Sufixo do input */
    sufix: {
      type: String,
      default: ''
    },
    /** Tipo do input */
    type: {
      type: String,
      default: 'text'
    },
    /** Placeholder do campo vazio */
    placeholder: {
      type: String,
      default: ''
    },
    /** Desabilita a edição */
    disabled: {
      type: Boolean,
      default: false
    },
    currency: {
      type: Boolean,
      default: false
    },
    /** Valores mínimo e máximo */
    max: {
      type: Number,
      default: null
    },
    min: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      inFocus: false
    }
  },
  computed: {
    ...mapGetters('hotel', ['getCurrency'])
  }
}
</script>

<style lang="scss" scoped>
.table-cell {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 0 0 transparent inset;
  transition: box-shadow $anim-fast linear;

  label,
  span,
  input {
    cursor: pointer;
  }

  .content-wrapper {
    display: flex;
    align-items: center;
    padding: 12px 15px;
  }

  .currency {
    color: inherit;
    transition: color $color-anim linear;
  }

  input {
    @include reset-input();
    width: 100%;
    height: 100%;
  }

  &__focus {
    box-shadow: 0 0 1px 2px $blue inset;

    .currency {
      color: $gray-mid;
    }
  }

  &__disabled {
    pointer-events: none;
    opacity: 0.7;
    user-select: none;
  }
}
</style>
